export default __webpack_public_path__ + "static/media/ESA.137ce584.svg";